'use client'
import Button from "@/ui/button";

export default function FooterButton() {
    function scrollToTop(event) {
        event.preventDefault();
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
    }
    
    return (
        <a href="#" onClick={scrollToTop}>
          <Button type="arrow-top-black" />
        </a>
    );
}
